import { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import SEO from "../components/SEO";
import HeroSection from "../components/HeroSection";
import AboutSection from "../components/AboutSection";
import BlogSection from "../components/BlogSection";
import PricingSection from "../components/PricingSection";
import ArticleList from "../components/ArticleList";
import { collection, getDocs } from "firebase/firestore/lite";
import Header from "../components/Header";
import Footer from "../components/Footer";
import NewsLetter from "../components/NewsLetter";
import { bookingService } from "../services/bookingService";
import { Box, Container, Typography, Grid, Card, CardContent, Button } from "@mui/material";
import { CalendarMonth } from "@mui/icons-material";

function Home(props) {
  const [articles, setArticles] = useState([]);
  const [lessonTypes, setLessonTypes] = useState([]);
  const navigate = useNavigate();

  const getData = useCallback(async () => {
    const col = collection(props.db, "articles");
    const snapshot = await getDocs(col);
    let list = snapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
    list = list.filter((article) => article.published);
    const pinnedIndex = list.findIndex((article) => article.pinned);
    if (pinnedIndex !== -1) {
      const articlePinned = list.splice(pinnedIndex, 1)[0];
      list.sort(
        (a, b) =>
          new Date(
            b.date.seconds * 1000 + Math.round(b.date.nanoseconds / 1e6)
          ) -
          new Date(a.date.seconds * 1000 + Math.round(a.date.nanoseconds / 1e6))
      );
      list.unshift(articlePinned);
    }
    setArticles(list);
  }, [props.db]);

  const getLessonTypes = useCallback(async () => {
    try {
      const types = await bookingService.getLessonTypes();
      setLessonTypes(types);
    } catch (error) {
      console.error("Error loading lesson types:", error);
    }
  }, []);

  useEffect(() => {
    getData();
    getLessonTypes();
  }, [getData, getLessonTypes]);

  return (
    <div className="home">
      <SEO title="Home" />
      <Header />
      <section id="home">
        <HeroSection />

        <Box id="chi-sono" sx={{ scrollMarginTop: '80px' }}>
          <AboutSection />
        </Box>

        {/* Esplora i Percorsi Section */}
        <Container id="percorsi" maxWidth="lg" sx={{ py: 8, scrollMarginTop: '10px' }}>
          <Typography
            variant="h3"
            component="h2"
            textAlign="center"
            gutterBottom
            sx={{
              fontWeight: "bold",
              color: "#145444",
              mb: 6
            }}
          >
            Esplora i Percorsi
          </Typography>

          <Grid container spacing={4}>
            {lessonTypes.map((lesson) => (
              <Grid item xs={12} sm={6} md={4} key={lesson.id}>
                <Card
                  sx={{
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    backgroundColor: "#f9f9f9",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                    borderRadius: 3,
                  }}
                >
                  <CardContent sx={{ flexGrow: 1, p: 3 }}>
                    <Typography
                      variant="h5"
                      component="h3"
                      gutterBottom
                      sx={{ fontWeight: "bold", color: "#145444" }}
                    >
                      {lesson.name}
                    </Typography>
                    <Typography variant="body1" color="text.secondary" paragraph>
                      {lesson.description}
                    </Typography>
                    <Box sx={{ mt: 2 }}>
                      <Typography variant="body2" color="text.secondary">
                        <strong>Durata:</strong> {lesson.duration} minuti
                      </Typography>
                    </Box>
                  </CardContent>
                  <Box sx={{ p: 2, pt: 0 }}>
                    <Button
                      variant="contained"
                      fullWidth
                      startIcon={<CalendarMonth />}
                      onClick={() => navigate("/prenotazioni")}
                      sx={{
                        backgroundColor: "#145444",
                        "&:hover": {
                          backgroundColor: "#0d3a2e",
                        },
                      }}
                    >
                      Prenota
                    </Button>
                  </Box>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>

        <PricingSection />

        <BlogSection />
        <section className="my-4">
          <ArticleList
            articles={articles}
            onArticleClick={(id) => navigate("/blog/" + id)}
          />
        </section>
      </section>
      <NewsLetter />
      <Footer />
    </div>
  );
}

export default Home;
